import { render, staticRenderFns } from "./reporteJugador.vue?vue&type=template&id=412d774c&"
import script from "./reporteJugador.vue?vue&type=script&lang=js&"
export * from "./reporteJugador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports